import { Link } from "react-router-dom";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import { site } from "@/data/site";

export default function Datenschutz() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50">
      <Header solid />
      <main className="w-full px-4 md:px-8 pt-32 pb-20">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-label text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Zurück zur Startseite
          </Link>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl font-semibold text-foreground-950">
            Datenschutzerklärung
          </h1>

          <div className="mt-10 space-y-8 font-body text-sm md:text-base leading-relaxed text-foreground-700">
            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                1. Verantwortlicher
              </h2>
              <p className="mt-3">
                Verantwortlich für die Datenverarbeitung auf dieser Website ist:
                <br />
                {site.name}, Inhaber {site.owner}
                <br />
                {site.street}, {site.city}
                <br />
                Telefon:{" "}
                <a href={site.phoneHref} className="text-primary-600 hover:underline cursor-pointer">
                  {site.phoneDisplay}
                </a>
                <br />
                E-Mail:{" "}
                <a href={site.emailHref} className="text-primary-600 hover:underline cursor-pointer">
                  {site.email}
                </a>
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                2. Erhebung und Verwendung Ihrer Daten
              </h2>
              <p className="mt-3">
                Beim Aufruf dieser Website werden durch den Hosting-Anbieter automatisch
                Informationen in Server-Logfiles gespeichert, die Ihr Browser übermittelt. Dies sind
                insbesondere Datum und Uhrzeit des Zugriffs, die aufgerufene Seite, Browsertyp und
                Betriebssystem sowie die IP-Adresse. Diese Daten dienen ausschließlich dem sicheren
                und stabilen Betrieb der Website und werden nicht mit anderen Datenquellen
                zusammengeführt.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                3. Kontaktformular
              </h2>
              <p className="mt-3">
                Wenn Sie uns über das Kontaktformular eine Anfrage senden, werden die von Ihnen
                angegebenen Daten (Name, Telefonnummer, E-Mail-Adresse, Anliegen und Nachricht) zum
                Zweck der Bearbeitung Ihrer Anfrage und für den Fall von Anschlussfragen bei uns
                gespeichert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b bzw. lit. f DSGVO. Diese Daten
                geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                4. Ihre Rechte
              </h2>
              <p className="mt-3">
                Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
                Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung Ihrer
                personenbezogenen Daten. Zudem können Sie sich bei einer Datenschutz-Aufsichts­behörde
                beschweren.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                5. Kontakt in Datenschutzfragen
              </h2>
              <p className="mt-3">
                Bei Fragen zum Datenschutz erreichen Sie uns jederzeit unter{" "}
                <a href={site.emailHref} className="text-primary-600 hover:underline cursor-pointer">
                  {site.email}
                </a>{" "}
                oder telefonisch unter {site.phoneDisplay}.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}